import HeroSection from './components/HeroSection';
import TickerStrip from '@/components/feature/TickerStrip';
import SeasonOverview from './components/SeasonOverview';
import RankingSection from './components/RankingSection';
import FeaturedSection from './components/FeaturedSection';
import CategoriesSection from './components/CategoriesSection';
import ContestantsSection from './components/ContestantsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import JsonLd from '@/components/base/JsonLd';
import { useSeo, buildAbsoluteUrl } from '@/hooks/useSeo';
import { works } from '@/mocks/works';
import { faqs, siteInfo } from '@/mocks/site';

const title = '黑料大赛 - 参赛作品合集围观 | 热门作品榜与选手盘点';
const description =
  '黑料大赛参赛作品一站看全：按热度整理作品合集与投稿展示，热门作品榜、选手盘点持续更新，想围观高质量爆料现场，直接进来。';
const keywords = '黑料大赛,黑料大赛作品合集,黑料大赛参赛作品,黑料大赛热门作品,黑料大赛选手盘点';

export default function Home() {
  useSeo({ title, description, keywords, path: '/' });

  const homeUrl = buildAbsoluteUrl('/');

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: homeUrl,
        description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${buildAbsoluteUrl('/works')}?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: homeUrl,
        email: siteInfo.email,
        description: siteInfo.description,
        slogan: siteInfo.slogan,
      },
      {
        '@type': 'WebPage',
        name: title,
        url: homeUrl,
        description,
        inLanguage: 'zh-CN',
        isPartOf: { '@type': 'WebSite', url: homeUrl },
      },
      {
        '@type': 'ItemList',
        name: '黑料大赛热门作品榜',
        itemListOrder: 'https://schema.org/ItemListOrderAscending',
        numberOfItems: works.length,
        itemListElement: works.map((work) => ({
          '@type': 'ListItem',
          position: work.rank,
          name: work.title,
          url: buildAbsoluteUrl(`/works/${work.id}`),
        })),
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
  };

  return (
    <>
      <JsonLd data={schema} />
      <HeroSection />
      <TickerStrip />
      <SeasonOverview />
      <RankingSection />
      <FeaturedSection />
      <CategoriesSection />
      <ContestantsSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}